import * as service from './Icecontacts.services'
export default {
  data() {
    return {

      currentuseremail: '',
      personaldetails: [],
      iseditable: true,
      // imgSrc: '',
      // suitsize: [],
      fileImg: '',
      personalForm: {
        FirstName: '',
        LastName: '',
        Relation: '',
        PhoneNumber: '',
        altFirstName: '',
        altLastName: '',
        altRelation: '',
        altPhone: '',
        altMiddleName: '',
        MiddleName: '',
        MedicalCondition: '',
        MedicalNotes: '',
        Allergies: '',
        SpecialInstructions: '',

      },
      responseModel: []

    }
  },

  props: ['data', 'editShow'],
  watch: {
    data: function () {

      this.responseModel = {
        PersonnelId: this.data.response.PersonnelId,
        FirstName: this.data.response.PersonnelEmergency[0].FirstName,
        LastName: this.data.response.PersonnelEmergency[0].LastName,
        Relation: this.data.response.PersonnelEmergency[0].Relation,
        MiddleName: this.data.response.PersonnelEmergency[0].MiddleName,
        PhoneNumber: this.data.response.PersonnelEmergency[0].PhoneNumber,
        altFirstName: this.data.response.PersonnelEmergency[1].FirstName,
        altLastName: this.data.response.PersonnelEmergency[1].LastName,
        altMiddleName: this.data.response.PersonnelEmergency[1].MiddleName,
        altRelation: this.data.response.PersonnelEmergency[1].Relation,
        altPhoneNumber: this.data.response.PersonnelEmergency[1].PhoneNumber,
        MedicalCondition: this.data.response.MedicalCondition,

        Allergies: this.data.response.Allergies,
        MedicalNotes: this.data.response.MedicalNotes,
        SpecialInstructions: this.data.response.SpecialInstructions
      }

      this.contBackup = deepcopy(this.responseModel)

      this.personalForm = this.contBackup




    }

  },

  mounted() {


  },

  methods: {

    modalCancel() {
      if ($('#PostsignupModel').length > 0) {
        $('#PostsignupModel').modal('hide')
      } else {

        this.personalForm = deepcopy(this.responseModel)

        this.data['isEdit'] = false

      }
      this.data['isEdit'] = false
    },
    backProfile() {
      this.$router.push('/addpersonnel')

    },

    cEdit() {

      if (this.data["isEdit"] == true) {
        this.data["isEdit"] = false
      } else if (this.data["isEdit"] == false) {
        this.data["isEdit"] = true
      }

    },
    save(formName) {
      let context = this


      var formdata = {
        PersonnelId: this.data.response.PersonnelId,
        MedicalCondition: context.personalForm.MedicalCondition,
        Allergies: context.personalForm.Allergies,
        MedicalNotes: context.personalForm.MedicalNotes,
        SpecialInstructions: context.personalForm.SpecialInstructions,
        PersonnelEmergency: [{
            PersonnelId: this.data.response.PersonnelId,
            Type: 1,
            FirstName: context.personalForm.FirstName,
            LastName: context.personalForm.LastName,
            PhoneNumber: context.personalForm.PhoneNumber,
            MiddleName: context.personalForm.MiddleName,
            Relation: context.personalForm.Relation,
          },
          {
            PersonnelId: this.data.response.PersonnelId,
            Type: 2,
            FirstName: context.personalForm.altFirstName,
            LastName: context.personalForm.altLastName,
            PhoneNumber: context.personalForm.altPhoneNumber,
            MiddleName: context.personalForm.altMiddleName,
            Relation: context.personalForm.altRelation,
          }
        ]
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {


          loader.startLoader()

          service.SaveIceContact(formdata).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              return;
            }

            //FG - FOOF - AFTER CERT - First Release Security - seems the broadcast below is not needed
            //            AND when it is in place causes problems
            //context.$router.app.$emit('updatedinfo')

            context.data['isEdit'] = true
            context.$notify({

              title: 'Success',

              message: 'Personnel Details Updated',

              type: 'success'

            })
            loader.stopLoader()

          }, (error) => {

            context.data['isEdit'] = true
            context.personalForm = deepcopy(context.responseModel)
            context.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
            loader.stopLoader()

          })

        }
      })

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/ICEcontacts/Icecontacts.controller.js